import { createCarouselSlice } from './createCarouselSlice'

/**
 * Redux slice for the "Buy again" recommendations carousel.
 * State shape and reducers come from `createCarouselSlice`.
 * @internal
 */
export const buyAgainSlice = createCarouselSlice('buyAgainSlice')

export const { setItems: setBuyAgainItems, setStatus: setBuyAgainStatus } =
  buyAgainSlice.actions

export default buyAgainSlice.reducer
